// Size chart templates and helpers.
// A structured size chart is: { template, fit_note, columns, rows:[{size, values:[]}] }
// Legacy support: a product may still carry size_chart as a free-text string.

export const SIZE_TEMPLATES = {
  top: {
    label: 'Top',
    columns: ['Chest', 'Waist', 'Length'],
  },
  bottom: {
    label: 'Bottom',
    columns: ['Waist', 'Hip', 'Inseam'],
  },
  outerwear: {
    label: 'Outerwear',
    columns: ['Chest', 'Shoulder', 'Sleeve', 'Length'],
  },
};

export const TEMPLATE_OPTIONS = [
  { value: 'top', label: 'Top' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'outerwear', label: 'Outerwear' },
];

// True if the product carries a structured chart ({...}) rather than legacy text.
export function isStructuredChart(sizeChart) {
  return Boolean(sizeChart && typeof sizeChart === 'object' && Array.isArray(sizeChart.rows));
}

// Normalise a product's size_chart into a usable structured object (or null). Falls back
// gracefully from structured -> legacy text-row -> null.
export function chartData(sizeChart) {
  if (isStructuredChart(sizeChart)) {
    return {
      template: sizeChart.template || '',
      fit_note: sizeChart.fit_note || '',
      columns: Array.isArray(sizeChart.columns) ? sizeChart.columns : [],
      rows: Array.isArray(sizeChart.rows) ? sizeChart.rows : [],
    };
  }
  return null;
}

// Build a fresh empty chart from a template name.
export function blankChart(template, sizes = []) {
  const columns = SIZE_TEMPLATES[template]?.columns || [];
  return {
    template,
    fit_note: '',
    columns,
    rows: sizes.map((s) => ({ size: s, values: columns.map(() => '') })),
  };
}